import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, rydeColors } from "@ryde/theme";

export const ConfirmPassengerDeleteContent = styled.div`
  padding-top: 10px;
  padding-inline-start: 20px;
  padding-inline-end: 10px;
  li {
    padding-bottom: 4px;
    label {
      font-weight: 500;
      padding-inline-end: 4px;
      color: ${greyMui._500};
    }

    span {
      font-weight: 500;
      padding-inline-end: 4px;
      color: ${blueGreyMui._700};
    }
  }
  .pass_more_info {
    color: ${greyMui._700};
    padding-top: 5px;

    .count_label {
      font-weight: 800;
      color: ${greyMui._900};
      padding-inline-start: 3px;
      padding-inline-end: 3px;
    }
  }
`;

export const ConfirmRideContent = styled.div`
  padding-top: 10px;
  padding-inline-start: 20px;
  padding-inline-end: 10px;
`;

export const ConfirmCancelRidePromptContent = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "confirm-cancel-rides-prompt-content-wrapper",
  },
)`
  padding-block: 20px;
  padding-inline-start: 20px;
  padding-inline-end: 10px;
  font-size: 14px;
  font-weight: 400;

  .ride_numbers {
    color: ${rydeColors.red};
    font-weight: 600;
  }

  .main_message {
    padding-inline-start: 6px;
  }

  .sub_message {
    display: block;
    margin-top: 10px;
  }
`;

export const CancelationReasonFieldStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "cancelation-reason-field",
  },
)`
  padding-block: 0 20px;
  padding-inline-start: 20px;
  padding-inline-end: 10px;

  label {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 500;
    color: ${greyMui._700};
  }

  textarea {
    width: 100%;
    min-height: 72px;
    padding: 8px 10px;
    font-family: inherit;
    font-size: 14px;
    color: ${greyMui._900};
    border: 1px solid ${blueGreyMui._200};
    border-radius: 6px;
    resize: vertical;

    &:focus {
      outline: none;
      border-color: ${rydeColors.steel};
    }
  }
`;

export const ConfirmMessageWithNumberWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "confirm-message-with-number-wrapper",
  },
)`
  padding-block: 20px;
  padding-inline-start: 20px;
  padding-inline-end: 10px;
  font-size: 14px;
  font-weight: 400;
  .number {
    color: ${rydeColors.red};
    font-weight: 600;
  }
  .main_message {
    padding-inline-start: 6px;
  }
  .sub_message {
    display: block;
    margin-top: 10px;
  }
`;
